import React, { Component,useState,useEffect,useContext } from 'react';
import { Redirect , Link, useHistory } from "react-router-dom";
import AppContext from '../../Context/AppContext';
import BlueButton from '../../Components/BlueButton';
import Header from "../../Components/Lista/HeaderCheckin";
import styled from "styled-components";

const InputContainer=styled.div`
display:grid;
justify-content: center;
justify-items: center;
justify-self: center;
`;

const InputText=styled.input`
text-align:center;
margin-top:7.5px;
border: 1px solid #bbbbbd;
font-size:18px;
width:297px;
height:55px;
border-radius:6px;
outline:none;
@media screen and (max-width:428px)
{
    width:100%;
}
`;

const SubText=styled.p`
margin:7.5px 0 0 0 0;
color:red;
justify-self:start;
`;

const Nombre=()=>
{
    const History=useHistory();
    const {Customer} = useContext(AppContext);
    const [Name, setName] = useState("");
    const [CorrectFormat, setCorrectFormat] = useState(false)

    useEffect(()=>
    {
        const {count}=Customer;
        if(count===undefined)
        {
            History.replace("/lista")
        }
    },[])


    const handleValidateName=e=>
    {
        setName(e.target.value)
        if(e.target.value.length===0)
        { 
            setCorrectFormat(false);
            return false;
        }
        else
        {
            setCorrectFormat(true);
            return true;
        }
    }

    const Submit=()=>
    {
        Customer.name=Name;
        History.push("/lista/telefono")
    }

    return <>
    <Header/>
    <div style={{margin:"20px 0 0"}}>
        <InputContainer>
            <h2 style={{justifySelf:"start",margin:"7.5px 0 0 0"}}>Nombre <span style={{color:"red"}}>*</span></h2>
            {CorrectFormat ? <InputText autoFocus value={Name} onChange={handleValidateName}/> : <InputText autoFocus value={Name} onChange={handleValidateName} style={{border:"1px solid red"}}/>}
            {!CorrectFormat ? <SubText>Obligatorio</SubText> : ""}
            {CorrectFormat ? <BlueButton onClick={Submit}>Confirmar</BlueButton> : null}
        </InputContainer>
    </div>
 </>
}

export default Nombre;